import { selectAll } from "../utils/utils";
import Swiper from 'swiper/bundle';

export class FeaturedCollections {
  constructor(el) {
    if (el) {
      this.init(el);
    }
  }

  init(el) {
    this.el = el;
    this.props();
    this.render();
  }

  props() {
    this.customReviewsContainer = selectAll("[data-featured-collections]");
  }

  render() {
    this.customReviewsCarousel();
  }

  customReviewsCarousel = () => {
    for (var i = 0; i < this.customReviewsContainer.length; i++) {
      new Swiper(this.customReviewsContainer[i], {
        slidesPerView: 1,
        spaceBetween: 16,
        scrollbar: {
          el: '.swiper-scrollbar',
          draggable: true,
        },
        breakpoints: {
          991: {
            slidesPerView: 3,
            spaceBetween: 104,
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
          }
        }
      });
    };
  };
}